import { PolicyActionEnum } from '../actions.js';
import { defineBuiltinPolicy } from './types.js';

/**
 * Diagnostic views for people debugging the platform. It holds no built-in role: attach it to a user or
 * a custom role next to whatever else they need. These are the only built-in holders of these actions,
 * so the InsightEdge and chat policies stay free of them.
 */
export const debuggerPolicy = defineBuiltinPolicy({
  key: 'builtin:debugger',
  name: 'Debugger',
  description:
    'View LLM trace links in chat and the parsed content of files (indexed chunks and slide data).',
  actions: [PolicyActionEnum.ChatTraceView, PolicyActionEnum.IeFileViewParseDebug],
});
